import Vue from 'vue'
// // import VueScrollReveal from 'vue-scroll-reveal'
// import Slick from 'vue-slick'
// import '~/node_modules/slick-carousel/slick/slick.css'
// import '~/node_modules/slick-carousel/slick/slick-theme.css'
// eslint-disable-next-line import/no-named-as-default
import BootstrapVue from 'bootstrap-vue'
// // import inViewportDirective from 'vue-in-viewport-directive'
// // import 'bootstrap/dist/css/bootstrap.css'
// // import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueScrollTo from 'vue-scrollto'

// // Vue.directive('in-viewport', inViewportDirective)
Vue.use(BootstrapVue)
Vue.use(VueScrollTo)
// // Vue.use(VueScrollReveal, {
// //   class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
// //   duration: 800,
// //   scale: 1,
// //   distance: '30px',
// //   mobile: true,
// //   delay: 350
// // })

Vue.component('slick', Slick)
